<!--Tabla de últimas transacciones de planes(afiliaciones)
    Solo se muestra en el dashboard de organización si es que existe alguna transaccion de afiliación
-->
<template>
  <v-row justify="center" class="elevation-2 pa-5" v-if="transactions.length > 0">
    <v-col cols="12">
      <v-row justify="center" align="end">
        <v-col cols="6" sm="7" md="8" lg="9">
          <span class="headline font-weight-bold mr-5">Últimas transacciones (Afiliaciones)</span>
          <v-btn color="accent" class="black--text font-weight-bold" @click="downloadCsv(transactions)">
            Reporte<v-icon right>mdi-download</v-icon>
          </v-btn>
        </v-col>

        <!-- BOTÓN PARA DESCARGAR UN REPORTE EN EXCEL -->
        <v-col cols="6" sm="5" md="4" lg="3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
            class="mr-0 mr-md-5"
          ></v-text-field>
  <!--
          <v-row justify="end" class="mr-5">
            <v-btn color="accent" class="black--text font-weight-bold" @click="downloadCsv(transactions)">
              Reporte<v-icon right>mdi-download</v-icon>
            </v-btn>
            
            <v-icon
              v-bind:style="getSize"
              class="excel-icon pointer"
              @click="downloadCsv(transactions)"
            >fas fa-file-excel</v-icon>
          </v-row>-->
        </v-col>

      </v-row>

      <v-divider></v-divider>

      <!-- CONTENIDO DE LA TABLA -->
      <v-data-table
        no-data-text="No hay datos disponibles."
        no-results-text="No hay datos disponibles."
        loading-text="Cargando datos..."
        class="table-header"
        :search="search"
        :calculate-widths="true"
        :headers="transactionsHeaders"
        :items="transactions"
        :items-per-page="($vuetify.breakpoint.xsOnly)?3:10"
        :loading="loading"
        :header-props="{
          sortByText:'Ordenar por'
        }"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
          itemsPerPageAllText:'Todas',
        }"
      >
        <template v-slot:body="{items}">
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="index"
              class="text-center"
              :class="[($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-table-row':'' ]"
            >
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[0].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{item.plan}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[1].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{item.buyer}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[2].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{item.company || 'N/D' }}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[3].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{ item.email || 'N/D'}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[4].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{item.paymentMethod}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[5].text}}</div>
                <div :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''">
                  <v-chip
                    :color="(item.status=='Completado')?'success':'secondary'"
                    dark
                  >{{ item.status }}</v-chip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[6].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >${{ item.total | currency}}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[7].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >
                <v-chip
                    v-if="item.bill && item.bill.email"
                    color='secondary'
                    @click.native.stop="showDataBill(item.bill)"
                    dark
                  >
                    <v-icon small>fas fa-check</v-icon>
                  </v-chip>
                <v-chip
                    v-else
                    color='grey lighten-1'
                    dark
                  >
                    <v-icon small>fas fa-times</v-icon>
                  </v-chip>
                </div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[8].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{ item.date }}</div>
              </td>
              <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                <div
                  class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                >{{transactionsHeaders[9].text}}</div>
                <div
                  :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                >{{ item.hour }}</div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <!-- DIALOG PARA VER INFORMACIÓN DE FACTURACIÓN -->
      <v-dialog v-if="billingDialog" v-model="billingDialog" persistent width="500" overlay-opacity="0.2">
        <v-card>
          <v-card-title class="headline font-weight-bold text-center">Información de facturación</v-card-title>
          <v-divider class="pt-3"></v-divider>
          <div class="mx-5">  
            <p><strong>Razón social/Nombre fiscal:</strong> {{billingData.razonSocialONombreFiscal}}</p>
            <p><strong>RFC:</strong> {{billingData.rfc}}</p>
            <p v-if="billingData.address"><strong>Dirección:</strong> {{billingData.address}}</p>
            <p v-if="billingData.zipCode"><strong>Código postal:</strong> {{billingData.zipCode}}</p>
            <p><strong>CFDI:</strong> {{billingData.usoDelCfdi}}</p>
            <p><strong>Forma de pago:</strong> {{billingData.formaDePago}}</p>
            <p><strong>Método de pago:</strong> {{billingData.metodoDePago}}</p>
            <p><strong>E-mail:</strong> {{billingData.email}}</p>
          </div>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="billingDialog = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { async } from "q";
export default {
  data() {
    return {
      loading: true,
      transactionsHeaders: [
        { align: "center", text: "Afiliación", value: "plan" },
        { align: "center", text: "Titular", value: "buyer" },
        { align: "center", text: "Empresa/Institución", value: "company" },
        { align: "center", text: "Email", value: "email" },
        { align: "center", text: "Método de pago", value: "paymentType" },
        {
          align: "center",
          text: "Estatus del pago",
          width: "150px",
          value: "status"
        },
        { align: "center", text: "Total", value: "total" },
        { align: "center", text: "Factura", value: "bill" },
        { align: "center", text: "Fecha", value: "date" },
        { align: "center", text: "Hora", width: "90px", value: "hour" },
      ],
      transactions: [],
      billingDialog: false,
      billingData: {},
      search: ""
    };
  },
  computed: {
    ...mapState("order", ["orders"]),
    ...mapState("affiliation", ["organizationAffiliations"]),
    getSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size:1.8em";
        case "sm":
          return "font-size:1.8em";
        case "md":
          return "font-size:1.5em";
        case "lg":
          return "font-size:1.6em";
        case "xl":
          return "font-size:1.7em";
      }
    }
  },
  methods: {
    ...mapActions("order", ["fetchOrdersInformation"]),
    ...mapActions("affiliation", ["fetchOrganizationAffiliations"]),
    /**
     * Función para descargar el reporte de las ordenes.
     * @param { Array<Object> } affiliations Arreglo de transacciones de todos los eventos de una organización.
     */
    downloadCsv(affiliations) {
      const header = [
        "Afiliacion",
        "Afiliado",
        "Empresa_Institucion",
        "Telefono",
        "Metodo_de_pago",
        "Email",
        "Estatus",
        "Total",
        "Dia",
        "Hora",
        "Factura",
        "RazonSocial_NombreFiscal",
        "Rfc",
        "Cfdi",
        "FormaDePago",
        "MetodoDePago",
        "EmailFactura"
      ];
      // Llenar el arreglo de items con affiliados, para esto se aplican algunos formatos
      let items = [];
      affiliations.forEach(affiliation => {
        let currentAffiliation = {};
        currentAffiliation.Afiliacion = affiliation.plan;
        currentAffiliation.Afiliado = affiliation.buyer;
        currentAffiliation.Empresa_Institucion = affiliation.company;
        if (affiliation.company != "") {
          currentAffiliation.Empresa_Institucion = affiliation.company;
        } else {
          currentAffiliation.Empresa_Institucion = "N/D"
        }
        if (affiliation.phone != "") {
          currentAffiliation.Telefono = affiliation.phone;
        } else {
          currentAffiliation.Telefono = "N/D";
        }
        currentAffiliation.Metodo_de_pago = affiliation.paymentMethod;
        currentAffiliation.Email = affiliation.email;
        currentAffiliation.Estatus = affiliation.status;
        currentAffiliation.Total = affiliation.total;
        currentAffiliation.Dia = affiliation.date;
        currentAffiliation.Hora = affiliation.hour;
        if (affiliation.bill && affiliation.bill.email) {
          currentAffiliation.Factura = "Si";
          currentAffiliation.RazonSocial_NombreFiscal = affiliation.bill.razonSocialONombreFiscal
          currentAffiliation.Rfc = affiliation.bill.rfc
          currentAffiliation.Cfdi = affiliation.bill.usoDelCfdi
          currentAffiliation.FormaDePago = affiliation.bill.formaDePago
          currentAffiliation.MetodoDePago = affiliation.bill.metodoDePago
          currentAffiliation.EmailFactura = affiliation.bill.email
        } else {
          currentAffiliation.Factura = "No";
        }
        items.push(currentAffiliation);
      });

      const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here
      let csv = items.map(row =>
        header
          .map(fieldName => JSON.stringify(row[fieldName]), replacer)
          .join(",")
      );
      csv.unshift(header.join(","));
      csv = csv.join("\r\n");
      var link = window.document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv)
      );
      link.setAttribute("download", "Ultimas_transacciones_afiliaciones.csv");
      link.click();
    },

    /**
     * Función modifica el estado de las ordenes a una forma amigable al usuario.
     * @param { string } estatus El estado actual de una transacción.
     */
    formatEstatus(estatus) {
      if (estatus == "IN_PROGRESS") {
        return "En progreso";
      } else {
        return "Completado";
      }
    },
    /**
     * Función modifica el método de pago de las ordenes a una forma amigable al usuario.
     * @param {string} paymentMethod El método de pago utilizado para la transacción.
     */
    formatPaymentMethod(paymentMethod) {
      let newPaymentMehtod = "";
      switch (paymentMethod) {
        case "CASH":
          newPaymentMehtod = "Efectivo";
          break;
        case "BANK_TRANSFER":
          newPaymentMehtod = "SPEI";
          break;
        case "CARD":
          newPaymentMehtod = "Tarjeta";
          break;
        case "PAYPAL":
          newPaymentMehtod = "PayPal";
          break;
        case "FREE":
          newPaymentMehtod = "Gratis";
          break;
        default:
          newPaymentMehtod = "N/D";
          break;
      }
      return newPaymentMehtod;
    },
    // deleteTicket(item) {
    //   this.deleteDialog = true;
    //   this.selectedItem = item;
    // },
    // async confirmTicketDelete() {
    //   this.deleteDialog = false;
    // },

    /**
     * Función para dar formato al objeto de la base de datos para su uso en la data table.
     */
    async formatAffiliations() {
      await this.fetchOrganizationAffiliations();
      this.transactions = this.organizationAffiliations.map(affiliation => {
        return {
          plan: affiliation.plan.name,
          buyer: `${affiliation.paymentInformation.name} ${affiliation.paymentInformation.lastName}`,
          company: affiliation.affiliateData.companyName,
          phone: affiliation.affiliateData.tel,
          paymentMethod: this.formatPaymentMethod(
            affiliation.paymentInformation.paymentType
          ),
          email: affiliation.paymentInformation.email,
          status: this.formatEstatus(affiliation.estatus),
          total: affiliation.tier.amount > 0 ? affiliation.tier.amount : "0",
          bill: affiliation.billingInformation,
          //date: affiliation.createdAt.substring(0,10)
          //date: affiliation.updatedAt.substring(0,10),
          //date: new Date(affiliation.updatedAt).toLocaleDateString("es-MX"),
          date: this.formatDate(affiliation.updatedAt),
          hour: this.formatHour(affiliation.updatedAt),
        };
      });
      this.transactions = this.transactions.filter(
        transaction =>
          !(
            transaction.paymentMethod == "Tarjeta" &&
            transaction.status == "En progreso"
          )
      );
    },
    /**
     * Función para mostrar dialog con la información de facturación
     * @param { Object } billingData Objeto que tiene los datos de facturación del cliente
     */
    showDataBill(billingData) {
      this.billingDialog = true;
      this.billingData = billingData;
    },
    /**
     * Función que obtiene la fecha de la transacción con el siguiente formato DD/MM/YYYY
     * @param {Date} date Valor de la fecha.
     */
    formatDate(date) {
      let newDate = new Date(date);
      return `${newDate.getDate()}/${newDate.getMonth()+1}/${newDate.getFullYear()}`
    },
    /**
     * Función que obtiene la hora de la transacción con el siguiente formato HH:MM A.M./P.M.
     * @param {Date} date Valor de la fecha.
     */
    formatHour(date) {
      let time = new Date(date);
      var hour = time.getHours();
      var minute = time.getMinutes();
      //var second = time.getSeconds();
      var temp = '' + ((hour > 12) ? hour - 12 : hour);
      if (hour == 0)
        temp = '12';
      temp += ((minute < 10) ? ':0' : ':') + minute;
      //temp += ((second < 10) ? ':0' : ':') + second;
      temp += (hour >= 12) ? ' P.M.' : ' A.M.';
      return temp;
    },
  },
  async mounted() {
    await this.formatAffiliations();
    this.loading=false;
    await this.fetchOrganizationAffiliations();
  }
};
</script>
<style scoped>
@media (min-width: 1264px) {
  td {
    width: 50px;
  }
}
.table-header >>> thead {
  background-color: rgb(231, 231, 231);
}
</style>
